import { ContextService } from '../services/context_service';
import { RechteService } from '../services/rechte_service';

export function getTabRechte(
    data: { disabled?: string[], prefix: string, tabs: string[] }, context?: { key: string, service: ContextService },
    callback?: (any: { rechte: any, tabIndex: number }) => void
): any {
    const { disabled, prefix, tabs } = data;
    
    if ((context && !(context || {}).key) || !prefix || !tabs) {
        return { rechte: {}, tabIndex: null };
    }
    const contextService: ContextService = (context || {}).service;
    const rechteService: RechteService = new RechteService;
    const all: boolean = rechteService.hasRecht('admin.tab.all')
        || rechteService.hasRecht(`${prefix}.all`);
    const rechte: any = { all };
    const bereiche: any = { handwerk: [], kultur: [], sonstige: [], system: [] };
    const bereichKeys: any = {
        'System-Administratoren': 'system', 'Admin-Handwerk': 'handwerk', 'Admin-Kultur': 'kultur', 'Admin-Sonstige': 'sonstige'
    };
    let tabIndex: number = null;

    const process = () => tabs.forEach((key: string, index: number) => {
        rechte[key] = (disabled || []).indexOf(key) === -1 ? all || rechteService.hasRecht(`${prefix}.${key}`) : false;

        if ((tabIndex === null && rechte[key]) || (context && index === contextService.get(context.key) && rechte[key])) {
            tabIndex = index;
        }

        if (typeof callback === 'function') {
            rechte[key] = { visible: rechte[key] };
            const groups: any = {};

            Object.keys(bereiche).forEach((bereich: string) => {
                groups[bereich] = bereiche[bereich][`${prefix}.${key}`] || bereiche[bereich]['admin.tab.all']
                || bereiche[bereich][`${prefix}.all`] || false
            });
            rechte[key].groups = groups;
        }
    });

    if (typeof callback === 'function') {
        rechteService.getRechteBasis('legacy', (data: any) => {
            ((data || {}).access_groups || []).forEach((item: any) => {
                const group: string = item.group_tid || null;

                if (bereichKeys[group] && typeof item.access_id === 'string') {
                    bereiche[bereichKeys[group]][item.access_id] = true;
                }
            });
            process();
            rechte.all = { visible: all };
            callback({ rechte, tabIndex });
        });
        return;
    }
    process();

    return { rechte, tabIndex };
}
